import {
  LooseBlade,
  Page,
  PageSchema,
} from "@riot-private/blades-ui/blades-api-client";
import {
  AllBladeContracts,
  AllBladeContractsSchema,
} from "@riot-private/blades-ui";
import { fromZodError } from "zod-validation-error";
import { ZodError } from "zod";

export function parsePageResponse(response: unknown): Page {
  try {
    return PageSchema.parse(response);
  } catch (error) {
    console.error(response);
    throw new Error(
      `Invalid response received from PCS API for the page details: ${error}`,
    );
  }
}

export class BladeValidationError extends Error {
  constructor(
    message: string,
    public cause: ZodError,
    public input: unknown,
  ) {
    super(message);
  }
}

export function formatBladeValidationError(error: BladeValidationError) {
  return fromZodError(error.cause, {
    issueSeparator: "\n * ",
    prefix: error.message,
    prefixSeparator: ":\n * ",
    unionSeparator: "\n    or ",
  }).toString();
}

export function parseBladeData(
  blade: LooseBlade,
  index: number,
): AllBladeContracts {
  try {
    return AllBladeContractsSchema.parse(blade);
  } catch (cause) {
    if (cause instanceof ZodError) {
      throw new BladeValidationError(
        `Invalid Blade data from blade [${index + 1}:${blade.type}]`,
        cause,
        blade,
      );
    }
    throw new Error(
      `Invalid Blade shape from blade [${index + 1}:${
        blade.type
      }]: ${cause} ${JSON.stringify(blade)}`,
      { cause: cause },
    );
  }
}
